/* eslint-disable indent */
import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import AppShell from './AppShell';
import * as serviceWorker from './serviceWorker';
import './ignoreDefaultPropsWarning';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<AppShell />);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
